import { Box, makeStyles, Paper, Typography } from "@material-ui/core";
import { useMemo, useState } from "react";
import LineChart from "src/components/ScoringChart/Line/LineChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import { tokenHistoryTitles } from "src/config/constants";
import useYAxisConfig from "src/hooks/useYAxisConfig";
import { numberWithCommas, toFixed } from "src/services/utils";
import SelectedTypeDrawer from "./SelectedTypeDrawer";

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "2rem",
    },
  },
  paper: {
    [theme.breakpoints.up("xs")]: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      boxShadow: "0px 1px 3px -2px #0000001F",
    },
    [theme.breakpoints.only("xs")]: {
      borderRadius: "10px",
      boxShadow: "0px 1px 3px 0px #0000001F",
    },
  },
}));

const getOption = (yAxisConfig) => {
  return {
    chart: {
      height: 370,
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: yAxisConfig,
    ...beautifulTooltip((value) => numberWithCommas(toFixed(value, 3))),
    legend: {
      enabled: true,
    },
  };
};

export default function TokenHistoryChart({ historyData }) {
  let [selectedTypes, setSelectedTypes] = useState(["credit_score_history"]);
  const cls = useStyle();

  const series = useMemo(() => {
    let result = [];
    if (historyData) {
      let index = 0;
      for (var _type of selectedTypes) {
        result.push({
          name: tokenHistoryTitles[_type],
          data: historyData[_type],
          type: "line",
          yAxis: index,
        });
        index++;
      }
    }
    return result;
  }, [historyData, selectedTypes]);

  const yAxisConfig = useYAxisConfig(
    series,
    (item) => item["data"],
    (item) => item[1]
  );

  return (
    <Box className={cls.root}>
      <Box pb={2}>
        <Typography variant="h4">Token Health History</Typography>
      </Box>
      <Paper className={cls.paper}>
        <SelectedTypeDrawer {...{ selectedTypes, setSelectedTypes }} />
        <LineChart series={series} option={getOption(yAxisConfig)} />
      </Paper>
    </Box>
  );
}
